import { SurveyTypeEnum } from "~/utils/enums/satisfaction-surveys.enums";

// Top-of-table sub-tabs on the cross-session Évaluations page (à chaud / à froid).
export enum GlobalEvaluationsTabEnum {
  HOT = "hot", // Enquêtes à chaud → SurveyTypeEnum.DIRECT
  COLD = "cold", // Enquêtes à froid → SurveyTypeEnum.DELAYED
}

export enum EvaluationsExportFormatEnum {
  EXCEL = "excel",
  CSV = "csv",
}

export const tabToSurveyType = (tab: GlobalEvaluationsTabEnum): SurveyTypeEnum =>
  tab === GlobalEvaluationsTabEnum.HOT ? SurveyTypeEnum.DIRECT : SurveyTypeEnum.DELAYED;
